const scheduleValidator = (value) => {
  try {
    const { parseExpression } = require('cron-parser');
    parseExpression(value);
    return true;
  } catch (err) {
    return "validate.schedule_format";
  }
};

export { scheduleValidator };